import React from "react";
import "./AccountInfoSection.css";
import TauriImage from "../../../TauriImage/TauriImage";

const AccountInfoSection = ({ title, data, Component, onEdit }) => {
    return (
        <div className="account-info-section">
            <div className="account-section-header">
                <div>{title}</div>
                {onEdit &&
                    <TauriImage
                        localImage={"/Images/bxs--edit.svg"}
                        alt="icon"
                        onClick={() => onEdit?.(data)}
                    />
                }
            </div>
            <div className="section-separator" />
            <Component data={data} />
        </div>
    );
};

export default AccountInfoSection;
